module.exports.witch = {
  vi: {
    title: 'Phù thủy (Witch) trong Avalon: ẩn Nhiệm vụ và kiểm tra phe',
    description:
      'Phù thủy làm gì trong Avalon? Tìm hiểu năng lực ẩn Nhiệm vụ dùng một lần, ai được kiểm tra phe và vì sao việc ẩn không làm thay đổi kết quả.',
    keywords: ['Phù thủy', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Bruxa em Avalon: missão oculta e verificação',
    description:
      'O que faz a Bruxa em Avalon? Ocultar uma missão uma vez, conceder uma verificação de lealdade e os limites da habilidade nesta plataforma.',
    keywords: ['Bruxa', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Witch in Avalon: Hidden Mission & Loyalty Check',
    description:
      'What does the Witch do in Avalon? Learn the one-use hidden mission ability, who receives a loyalty check and why hiding does not change the result.',
    keywords: ['Witch', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Ведьма в Авалоне: скрытая миссия и проверка',
    description:
      'Что делает Ведьма в Авалоне? Одноразовое сокрытие результата миссии, случайный обладатель проверки лояльности и ограничения способности.',
    keywords: ['Ведьма', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆巫婆：隱藏任務結果與陣營查驗',
    description: '阿瓦隆巫婆做什麼？了解一次性隱藏任務結果、隨機玩家獲得查驗權，以及隱藏不會改變真實任務結果的限制。',
    keywords: ['巫婆', '角色', '規則', '建議'],
  },
  'zh-CN': {
    title: '阿瓦隆巫婆：隐藏任务结果与阵营查验',
    description: '阿瓦隆巫婆做什么？了解一次性隐藏任务结果、随机玩家获得查验权，以及隐藏不会改变真实任务结果的限制。',
    keywords: ['巫婆', '角色', '规则', '建议'],
  },
  es: {
    title: 'Bruja en Avalon: misión oculta y comprobación',
    description:
      '¿Qué hace la Bruja en Avalon? Ocultar una misión una sola vez, otorgar una comprobación de lealtad y los límites de la habilidad en esta plataforma.',
    keywords: ['Bruja', 'Rol', 'Reglas', 'Consejos'],
  },
};
